import { render, staticRenderFns } from "./InterpreterInPerson.vue?vue&type=template&id=a611ac48&"
import script from "./InterpreterInPerson.vue?vue&type=script&lang=js&"
export * from "./InterpreterInPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports